import React from 'react'
import { Link } from 'react-router-dom'
import styled, { withTheme, css } from 'styled-components/macro'
import { lighten } from 'polished'
import FlashMessage from './FlashMessage'
import { button } from  'styles/mixins/textstyles'
import media from 'styles/mixins/media'
import { themeImage } from 'TrackApp'
import { Header as MainHeader,  HeaderContent } from 'components/layout/Main'
import { isTrackURL } from 'util/track'

const Header = styled(MainHeader)`
  background: ${props => props.theme.colors[props.theme.headerbg] || props.theme.headerbg || props.theme.colors.primaryDarker};
`

const TrackAnotherLink = styled(Link)`
  ${button()}
  padding: 2.3rem 3.5rem;
  color: ${props => props.theme.colors[props.theme.headerfg] || props.theme.headerfg || 'white'};

  &:hover {
    color: ${props => lighten(0.1, props.theme.colors[props.theme.headerfg] || props.theme.headerfg || 'white')};
  }

  ${media.mobile`
    display: none;
  `}
`

const LogoLink = styled.a`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 3.5rem;
`

const Content = styled.section`
  padding: 0;
`

const ThemeLogo = styled.img`
  height: ${props => props.height || '4.6rem'};
  ${props => props.width && css`
    width: ${props.width};
  `}
`

function getTrackAnotherLink(props) {
  const { themeName, match: { path } } = props
  if (path === '/' || path === '/:theme') {
    return null
  } else {
    return (
      <TrackAnotherLink to={isTrackURL() && themeName ? `/${themeName}` : '/'}>Track Another Delivery</TrackAnotherLink>
    )
  }
}

const TrackLayout = props => (
  <>
    <Header>
      <HeaderContent>
        <LogoLink href={props.theme.logo.link}>
          <ThemeLogo height={props.theme.logo.height} width={props.theme.logo.width} src={themeImage(props.themeName, props.theme.logo.src)} />
        </LogoLink>
        {getTrackAnotherLink(props)}
      </HeaderContent>
    </Header>
    <FlashMessage />
    <Content>{props.children}</Content>
  </> 
)

export default withTheme(TrackLayout)